import groupItems from '../utils/groupItems';
import getItemsFromCSV from '../utils/getItemsFromCSV';

export default async () => {
    const femaleNorwegianNames = await getItemsFromCSV(
        `${process.env.BASE_URL}csv/norwegianFemaleNamesAndMnemonics.csv`
    );

    return groupItems(femaleNorwegianNames);
};
